<template>
	<div id="printReport">
		<div class="container">
			<div class="col-sm-2">
				<img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
			</div>
			<div class="col-sm-8">
				<h3 class="text-center">Relatório de Inadimplência Mensal</h3>
			</div>
			<div class="col-sm-2"></div>
		</div>
		<br />

		<div class="row" id="conteudo">
			<div class="col-sm-12">
				<div class="panel panel-defaul">
					<div class="panel-body">
						<div class="row" id="dados">
							<div class="col-md-3">
								<label>Loja</label>
								<br />
								{{ !form.branche_id ? 'TODAS' : store_branch}}
							</div>
							<div class="col-md-3">
								<label>Periodo ({{ form.date_filter == 'cancel_at' ? 'Data do Cancelamento' : (form.date_filter == 'deployment_at' ? 'Data Alocação' : 'Data da Venda') }})</label>
								<br />
								<div>{{ form.interval.length ? moment(form.interval[0]).format('DD/MM/YYYY') : 'Todas' }} à {{ form.interval.length ? moment(form.interval[1]).format('DD/MM/YYYY') : 'Todas' }}</div>
							</div>
							<div class="col-md-3">
								<label>Administradora</label>
								<br />
								{{ !form.administrator_id ? 'TODAS' : administrator }}
							</div>
							<div class="col-md-3">
								<label>N° Parcela</label>
								<br />
								{{ !form.installments_order ? 'TODAS' : form.installments_order }}
							</div>

							<div class="col-md-3">
								<label>Vendedor</label>
								<br />
								{{ !form.salesman_id ? 'TODAS' : salesman }}
							</div>
						</div>
						<br />
					</div>
				</div>
			</div>
		</div>

		<div class="container" v-show="dataReport.length">
			<div class="col-md-12">
				<div class="panel panel-default">
					<div class="panel-body">
						<table class="table b-table table-sm" id="tabela">
							<thead class="thead-dark">
							<tr>
								<th class="text-center">Loja</th>
							</tr>
							</thead>
							<tbody>
							<template v-for="(name, key) of branchesNames">
								<tr :key="key">
									<td>
										<div>
											<a href="" @click.prevent.stop="showDetailsBranche( name, key);"><b>{{ name }}</b></a>
											<md-tooltip style="color:red;">Clique para exibir detalhes </md-tooltip>
										</div>
									</td>
								</tr>
							</template>
							</tbody>
						</table>
					</div>
				</div>

			</div>
		</div>

		<div class="container" v-if="show_detail">
			<div class="col-sm-12">
				<div class="panel panel-default">
					<div class="panel-body">
						<table class="table b-table table-sm" id="tabela2">
							<thead>
							<tr>
								<th colspan="10">Loja - {{branchesNames[indexReport]}}</th>
							</tr>
							</thead>
							<thead class="thead-dark">
							<tr>
								<th class="text-center" style="">Mês - Ano</th>
								<th class="text-center">Vendas</th>
								<th class="text-center">Valor</th>
								<th class="text-center">Propostas em Atraso</th>
								<th class="text-center">Parc. em Atraso</th>
								<th class="text-center">Valor</th>
								<th class="text-center">Cancelados</th>
								<th class="text-center">Valor</th>
								<th class="text-center">Total</th>
								<th class="text-center">Inadim %</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(iterator, key) of detail" :key="key">
								<td class="text-center">{{ iterator.month }}</td>
								<td class="text-center">{{ iterator.saleQty }}</td>
								<td class="text-center">{{ `R$ ${convertToDecimal(iterator.saleValue)}` }}</td>
								<td class="text-center">
									<div>
										<a href="" @click.prevent.stop="showProposals(key);"><b>{{ iterator.nonPaymentProposalQty }}</b></a>
										<md-tooltip style="color:red;">Clique para exibir detalhes </md-tooltip>
									</div>
								</td>
								<td class="text-center">{{ iterator.nonPaymentQty }}</td>
								<td class="text-center">{{ `R$ ${convertToDecimal(iterator.nonPaymentValue)}` }}</td>
								<td class="text-center">
									<div>
										<a href="" @click.prevent.stop="showCanceleds(key);"><b>{{ iterator.canceledQty }}</b></a>
										<md-tooltip style="color:red;">Clique para exibir detalhes </md-tooltip>
									</div>
								</td>
								<td class="text-center">{{ `R$ ${convertToDecimal(iterator.canceledValue)}` }}</td>
								<td class="text-center">{{ `R$ ${convertToDecimal(iterator.amount)}`  }}</td>
								<td class="text-center">{{ `${iterator.quantity.toFixed(2)}%` }}</td>
							</tr>
							<tr>
								<td class="text-right" style="background-color:#ccc;"><b>Totais:</b></td>
								<td class="text-center" style="background-color:#ccc;">{{ sumValue('saleQty') }}</td>
								<td class="text-center" style="background-color:#ccc;">R$ {{ convertToDecimal(sumValue('saleValue')) }}</td>
								<td class="text-center" style="background-color:#ccc;">{{ sumValue('nonPaymentProposalQty') }}</td>
								<td class="text-center" style="background-color:#ccc;">{{ sumValue('nonPaymentQty') }}</td>
								<td class="text-center" style="background-color:#ccc;">R$ {{ convertToDecimal(sumValue('nonPaymentValue')) }}</td>
								<td class="text-center" style="background-color:#ccc;">{{ sumValue('canceledQty') }}</td>
								<td class="text-center" style="background-color:#ccc;">R$ {{ convertToDecimal(sumValue('canceledValue')) }}</td>
								<td class="text-center" style="background-color:#ccc;">R$ {{ convertToDecimal(totalValue()) }}</td>
								<td class="text-center" style="background-color:#ccc;">{{ totalPercValue().toFixed(2) }}%</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>

		<div class="container" v-if="show_proposals">
			<div class="col-sm-12">
				<div class="panel panel-default">
					<div class="panel-body">
						<table class="table b-table table-sm" id="tabela2">
							<thead>
							<tr>
								<th colspan="8">Loja - {{branchesNames[indexReport]}} - {{dataReport[indexMonth].month}}</th>
							</tr>
							</thead>
							<thead class="thead-dark">
							<tr>
								<th class="text-center">Cliente</th>
								<th class="text-center">Contrato</th>
								<th class="text-center">Administradora</th>
								<th class="text-center">Grupo/Cota</th>
								<th class="text-center">Data Assembléia</th>
								<th class="text-center">Data Vencimento</th>
								<th class="text-center">Parcelas</th>
								<th class="text-center">Total</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(iterator, key) of proposals" :key="key">
								<td class="text-center"><a href="" @click.prevent.stop="redirectProposal(iterator);"><b>{{ iterator.client_name }}</b></a></td>
								<td class="text-center">{{ iterator.physical_proposal }}</td>
								<td class="text-center">{{ iterator.administrator_name }}</td>
								<td class="text-center">{{ iterator.group_name || 'Sem Grupo' }}/{{ iterator.quota || 'Sem Cota' }}</td>
								<td class="text-center">{{ iterator.first_meeting_at_name || 'Sem data' }}</td>
								<td class="text-center">{{ iterator.due_at_name }}</td>
								<td class="text-center">{{ iterator.installments_qty }}</td>
								<td class="text-center">{{ convertToDecimal(iterator.installments_total) }}</td>
							</tr>
							<tr>
								<td class="text-right" style="background-color:#ccc;"><b>Totais:</b></td>
								<td class="text-center" style="background-color:#ccc;">-</td>
								<td class="text-center" style="background-color:#ccc;">-</td>
								<td class="text-center" style="background-color:#ccc;">-</td>
								<td class="text-center" style="background-color:#ccc;">-</td>
								<td class="text-center" style="background-color:#ccc;">-</td>
								<td class="text-center" style="background-color:#ccc;">{{ sumProposalsValue('installments_qty') }}</td>
								<td class="text-center" style="background-color:#ccc;">{{ convertToDecimal(sumProposalsValue('installments_total')) }}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>

		<div class="container dont-print">
			<div class="col-md-12 text-center">
				<button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
				<button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
				<button type="button" v-show="detail.length" @click="excel()" class="btn btn-fill btn-success">Excel</button>
			</div>
		</div>
	</div>
</template>
<script>

import Vue from "vue";
import _ from "lodash";

export default {
	components: {},
	computed: {
		sum_commissions(){
			return (this.$store.state.reports.item.length) ? this.$store.state.reports.item[0].sum_commissions : [];
		},
		sum_commissions_details(){
			return (this.$store.state.reports.detail.length) ? this.$store.state.reports.detail[0].sum_commissions : [];
		},
		user_auth_name(){
			return this.$store.state.auth.user.name.toUpperCase();
		},
		branches() {
			return this.$store.state.defaults.branches;
		},
		dates: {
			get() {
				var dates = [
					{ id: "sale_date", name: "Data da Venda" },
					{ id: "due_date", name: "Data de Vencimento" },
					{ id: "payday", name: "Data de Pagamento" }
				];

				return dates;
			}
		},
	},
	data() {
		return {
			dataReport: [],
			indexReport: 0,
			branchesNames: [],
			moment: Vue.moment,
			administrator: null,
			dataAdministrador: [],
			store_branch: null,
			date_reference : null,
			init_at: null,
			end_at: null,
			form: {
				interval: [],
				installments_order: null
			},
			salesman: null,
			show_detail: false,
			branche_id_: null,
			detail: [],
			indexMonth: null,
			show_proposals: false,
			proposals: [],
		};
	},
	methods: {

		totalValue() {
			let total = 0;
			this.detail.forEach(iterator => {
				total+= iterator.amount;
			});
			return total;
		},
		totalPercValue() {
			let nonPayment = 0;
			let sales = 0;
			let total = 0;

			this.detail.forEach(iterator => {
				sales+=iterator.saleQty;
				nonPayment+= (iterator.canceledQty + iterator.nonPaymentProposalQty);
			});

			if(!sales) {
				sales = 1;
			}

			total = (nonPayment * 100) / sales;

			return total > 100 ? 100 : total;
		},
		sumValue(prop) {
			return this.detail.reduce((tot, value) => {return tot + value[prop] * 1},0);
		} ,
		sumProposalsValue(prop) {
			let total = 0;
			for (let id in this.proposals) {
				total += this.proposals[id][prop] * 1;
			}
			return total;
		} ,
		convertToDecimal(number) {
			return Number(parseFloat(number + ' ').toFixed(2)).toLocaleString('pt', {
				minimumFractionDigits: 2
			});
		} ,
		async showDetailsBranche(name, index){
			const self = this;
			this.indexReport = index;

			self.detail = self.dataReport.filter((value) => {
				if(value.branche_name == name) {
					return true;
				}
				return false;
			});

			self.show_detail = true;
			self.show_proposals = false;
		},
		showCanceleds(indexMonth) {
			const self = this;
			self.indexMonth = indexMonth;
			self.proposals = self.detail[indexMonth].data_canceled;
			self.show_proposals = true;
		},
		showProposals(indexMonth){
			const self = this;
			self.indexMonth = indexMonth;
			self.proposals = self.detail[indexMonth].data_line;
			self.show_proposals = true;
		},
		redirectProposal(data) {
			window.open('/proposals/'+data.proposal_id, '_blank');
		},
		close() {
			window.opener.focus();
			window.close();
		},
		async getDataBranches() {
			var self = this;

			self.$root.$emit("onLoading");

			const response = self.$store.dispatch("branches/all");

			response.then(function(_branches) {
				var branche = _branches.find(
						branche => branche.id === self.form.branche_id
				);
				if (branche !== undefined) {
					self.branche = branche.name;
				}
				self.$root.$emit("onLoading");
			});

			response.catch(function() {
				self.$root.$emit("onLoading");
			});

			await self.getData();
		},
		async getDataSalesmen() {
			var self = this;

			self.$root.$emit("onLoading");

			const response = self.$store.dispatch("users/all");

			response.then(function(_salesmen) {
				var salesman = _salesmen.find(
						salesman => salesman.id === self.form.salesman_id
				);
				if (salesman !== undefined) {
					self.salesman = salesman.name;
				}
				self.$root.$emit("onLoading");
			});

			response.catch(function() {
				self.$root.$emit("onLoading");
			});

		},
		async getDataAdministrators() {
			var self = this;

			self.$root.$emit("onLoading");

			const response = self.$store.dispatch('administrators/all');

			await response.then(async (data) => {
				self.dataAdministrador = await data;
				self.$root.$emit("onLoading");
			});
			//
			response.catch(function () {
				self.$root.$emit("onLoading");
			});
		},
		async getData(){
			var self = this;
			self.$root.$emit("onLoading");
			const response = self.$store.dispatch('reports/nonPaymentMontly', self.form);

			response.then(function (res) {
				self.dataReport = Object.values(res);

				self.dataReport.forEach((value, index) => {
					if(!self.branchesNames.includes(value.branche_name)) {
						self.branchesNames.push(value.branche_name);
					}
				})
				self.$root.$emit("onLoading");
			});

			response.catch(function () {
				self.$root.$emit("onLoading");
			});
		},
		print() {
			window.print();
		},
		excel() {
			var nome = "RELATÓRIO DE PRODUÇÃO INADIMPLÊNCIA MENSAL";
			var htmlPlanilha =
					'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
					nome +
					"</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
					nome +
					"</title></head><body><table>" +
					document.getElementById("tabela").innerHTML + document.getElementById("tabela2").innerHTML +
					"</table>";
			var htmlBase64 = btoa(htmlPlanilha);
			var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
			var hyperlink = document.createElement("a");
			hyperlink.download = "Relatório de Inadimplência Mensal";
			hyperlink.href = link;
			hyperlink.style.display = "none";
			document.body.appendChild(hyperlink);
			hyperlink.click();
			document.body.removeChild(hyperlink);
		},

	},
	async mounted() {
		var self = this;

		await self.getDataAdministrators();
		self.form = await JSON.parse(self.$route.query.form);

		await self.getDataBranches();
		await self.getDataSalesmen();
		self.store_branch   = self.form.branche_id ? self.branches.find(item => item.id === self.form.branche_id).name.toUpperCase() : null;
		self.date_reference = self.form.reference  ? self.dates.find(item => item.id === self.form.reference).name.toUpperCase()     : null;
		self.administrator   = self.form.administrator_id ? self.dataAdministrador.find(item => item.id === self.form.administrator_id).name.toUpperCase() : null;
		self.branche_id_ = self.form.branche_id;

		self.init_at = self.form.interval[0];

		self.end_at = self.form.interval[1];

	}
};
</script>
<style type="scss">
	@media print {
		.dont-print {
			display: none;
		}
	}
</style>

<style scoped>

</style>
